<template>
  <div>
    <page-header
      :page="headerPage"
      :actions="headerActions"
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    />
    <board class="mb-4" :details="studentBoardDetails">
      <template #data-item="{ item }">
        <div v-if="!item.data">
          <custom-balloon
            :background-color="item.statusColor"
            :text="item.statusName"
            dot
          />
        </div>
      </template>
    </board>
    <div class="bg-secondary-3 p-4 rounded mb-3">
      <div class="row">
        <div class="col-sm-12 col-md">
          <div class="classification-item d-flex align-items-start">
            <div
              class="m-1 mx-2 svg-icons svg-laptop-arrow-down-gray-green"
            ></div>
            <div>
              <span class="d-block text-neutral-gray">
                Equipos Clasificados:
              </span>
              <span class="d-block text-gray-green">
                {{ equipmentClassified.total | digit }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md">
          <div class="classification-item d-flex align-items-start">
            <div class="m-1 mx-2 svg-icons svg-laptop-arrow-down-orange"></div>
            <div>
              <span class="d-block text-neutral-gray">
                Clasificados por SIFDE:
              </span>
              <span class="d-block text-orange">
                {{ equipmentClassified.sifde | digit }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md">
          <div class="classification-item d-flex align-items-start">
            <div class="m-1 mx-2 svg-icons svg-laptop-arrow-down-green"></div>
            <div>
              <span class="d-block text-neutral-gray">
                Clasificados por Inventario:
              </span>
              <span class="d-block text-green">
                {{ equipmentClassified.inventory | digit }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md">
          <div class="classification-item d-flex align-items-start">
            <div>
              <span class="d-block text-neutral-gray">
                Última Fecha de Clasificación:
              </span>
              <div class="d-block font-20">
                {{ equipmentClassified.lastDate | date }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <custom-separator
      class="my-4 custom-separator"
      text="Equipos Pendientes de Clasificación"
    />
    <validation-observer no-validate ref="pendingEquipments">
      <div v-if="isAcquisition">
        <acquisition-equipment-row
          v-for="(item, index) in pendingEquipments"
          :key="index"
          :item="item"
          :classifications="classifications"
          :purchase-methods="purchaseMethods"
          :pei-at-service-id="peiAtServiceId"
          :is-read-only="isReadOnly"
          :validate="validate"
          :referral="referral"
          @refresh="getEquipmentsPendingClassification"
        />
      </div>
      <div v-else>
        <equipment-row
          v-for="(item, index) in pendingEquipments"
          :key="index"
          :item="item"
          :classifications="classifications"
          :purchase-methods="purchaseMethods"
          :is-read-only="isReadOnly"
          @refresh="refreshData()"
        />
      </div>
    </validation-observer>
    <div class="d-flex justify-content-end mt-3 mr-1" v-if="!isReadOnly">
      <action-button
        @click="save"
        i="fas fa-flag"
        variant="success"
        :text="this.isAcquisition ? 'Someter' : 'Guardar'"
      />
    </div>
  </div>
</template>
<script>
import PageHeader from 'PageHeader';
import Board from 'Board';
import CustomSeparator from 'custom-separator';
import EquipmentRow from './components/EquipmentRow.vue';
import AcquisitionEquipmentRow from './components/AcquisitionEquipmentRow.vue';
import CustomBalloon from 'custom-balloon';
import ActionButton from 'ActionButton';
import mixAlert from '@/mixins/alert.mixin';
import { date } from '@/utils/filters';
import referralService from '@/services/api/referralsandequipments.api';
import { ValidationObserver } from 'vee-validate';
import purchaseMethod from '@/utils/constants/purchaseMethods';
import peiATServiceStatus from '@/utils/constants/peiATServiceStatus';
import { getSysparameterByNames } from '@/services/api/sysparameter.api';
const REFERRAL_EQUIPMENT_ROUTE_NAME = 'referralsandequipment';

export default {
  components: {
    PageHeader,
    Board,
    CustomSeparator,
    EquipmentRow,
    AcquisitionEquipmentRow,
    ValidationObserver,
    CustomBalloon,
    ActionButton,
  },
  filters: {
    digit(value) {
      if (!value) return '00';
      return `${value}`.length > 1 ? `${value}` : `0${value}`;
    },
  },
  mixins: [mixAlert],
  data: () => ({
    isInventoryFlowEnabled: false,
    referral: {},
    validate: false,
    equipmentClassified: {},
    pendingEquipments: [],
    classifications: [],
    purchaseMethods: [],
  }),
  computed: {
    isReadOnly() {
      return (
        this.referral.serviceStatusId ==
        peiATServiceStatus.PendienteDeEntregaEscuela
      );
    },
    isAcquisition() {
      return this.isInventoryFlowEnabled && Boolean(this.referral.hasCatalog);
    },
    peiAtServiceId() {
      return Number(this.$route.params.id);
    },
    headerPage() {
      return {
        icon: 'fas fa-list',
        title: this.isAcquisition
          ? 'Análisis de Adquisición de Equipo'
          : 'Análisis de Requisición',
        routes: [
          'Asistencia Tecnológica',
          'Manejo de Referidos y Equipos',
          this.isAcquisition
            ? 'Análisis de Adquisición de Equipo'
            : 'Análisis de Requisición',
        ],
      };
    },
    headerActions() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () =>
            this.$router.push({ name: REFERRAL_EQUIPMENT_ROUTE_NAME }),
        },
        {
          text: this.isAcquisition ? 'Someter' : 'Guardar',
          icon: this.isAcquisition ? 'fas fa-flag' : 'fas fa-save',
          variant: 'success',
          visible: !this.isReadOnly,
          click: () => this.save(),
        },
      ];
    },
    studentBoardDetails() {
      return [
        [
          {
            label: 'Estudiante:',
            icon: 'fas fa-user',
            data: `${this.referral.studentName} - ${this.referral.studentSie}`,
            cols: 'col-12 col-md-3 pt-2',
          },
          {
            label: 'Número de Referido:',
            icon: 'fas fa-file-user',
            data: this.referral.referralNumber || '-',
            cols: 'col-12 col-md pt-2',
          },
          {
            label: 'Fecha de Referido:',
            icon: 'fas fa-calendar-minus',
            data: date(this.referral.referralDate),
            cols: 'col-12 col-md pt-2',
          },
          {
            label: 'CAAT:',
            icon: 'fas fa-location-dot',
            data: this.referral.caat || '-',
            cols: 'col-12 col-md pt-2',
          },
          {
            label: 'Estatus:',
            icon: 'fas fa-file-lines',
            statusColor: this.referral.serviceStatusColor,
            statusName: this.referral.serviceStatusName,
            cols: 'col-12 col-md-3 pt-2',
          },
        ],
      ];
    },
  },
  async mounted() {
    await this.getRecommendationSummary();
    await Promise.all([
      this.getEquipmentsClassified(),
      this.getEquipmentsPendingClassification(),
      this.getEquipmentClassifications(),
      this.getEquipmentPurchaseMethods(),
      this.getInventoryParam(),
    ]);
  },
  methods: {
    async getInventoryParam() {
      const { data } = await getSysparameterByNames({
        parameterNames: ['TechAssistanceServicesInventoryFlow'],
      });
      this.isInventoryFlowEnabled =
        data[0].staticValue && data[0].staticValue.toLowerCase() === 'true';
    },
    async getRecommendationSummary() {
      const { data } = await referralService.getReferralSummary(
        this.peiAtServiceId
      );
      this.referral = data;
    },
    async getEquipmentsClassified() {
      const { data } = await referralService.getEquipmentsClassified(
        this.referral.id
      );
      this.equipmentClassified = data;
    },
    async getEquipmentsPendingClassification() {
      const { data } = await referralService.getEquipmentsPendingClassification(
        this.referral.id
      );
      this.pendingEquipments = data.map((x, key) => ({ ...x, key }));
    },
    async getEquipmentClassifications() {
      const { data } = await referralService.getEquipmentClassifications();
      this.classifications = data;
    },
    async getEquipmentPurchaseMethods() {
      const { data } = await referralService.getEquipmentPurchaseMethods();
      this.purchaseMethods = data;
    },
    async save() {
      this.validate = true;
      var isValid = await this.$refs[`pendingEquipments`].validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Por favor completa los campos requeridos.',
          'error'
        );
        return;
      }

      const allDocumented = !this.pendingEquipments.some(
        (x) => x.purchaseMethod == null
      );

      if (!allDocumented) {
        this.ShowToast(
          'Error',
          'Necesita completar la documentación del método de compra.',
          'error'
        );
        return;
      }

      const hasPendingTransferRequests = this.pendingEquipments.some(
        (x) => x.equipment?.hasPendingTransferRequest
      );

      if (hasPendingTransferRequests) {
        this.ShowToast(
          'Error',
          'Actualmente al menos uno de los equipos se encuentra con una solicitud de transferencia en proceso.',
          'error'
        );
        return;
      }

      const allInventory = !this.pendingEquipments.some(
        (x) => x.purchaseMethod.id == purchaseMethod.SIFDE
      );

      if (
        this.referral.serviceStatusId ==
          peiATServiceStatus.PendienteAnalisisRequisicion &&
        !allInventory
      ) {
        const isConfirmed = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea cambiar el estatus del referido de Pendiente de Análisis Requisición a Pendiente de Requisición? (R03200005)?`,
          'Sí',
          'No'
        );
        if (!isConfirmed) {
          return;
        }
      } else if (allInventory) {
        const isConfirmed = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea cambiar el estatus del referido de ${this.referral.serviceStatusName} a Pendiente Entrega Escuela?`,
          'Sí',
          'No'
        );
        if (!isConfirmed) {
          return;
        }
      }

      const data = {
        peiAtServiceId: this.referral.id,
        details: this.pendingEquipments.map((e) => {
          return {
            equipmentClassificationId: e.classification.id,
            purchaseMethodId: e.purchaseMethod.id,
            inventoryType:
              e.purchaseMethod.id == purchaseMethod.Inventory
                ? e.inventoryType
                : null,
            peiAtSuggestedEquipmentId: e.peiAtSuggestedEquipmentId,
            recommendationId: e.recommendationId,
          };
        }),
      };
      referralService
        .saveEquipmentRecommendation(data)
        .then(async () => {
          this.ShowToast(
            'Éxito',
            'Información ha sido guardada exitosamente.',
            'success'
          );
          await Promise.all([
            this.getEquipmentsClassified(),
            this.getEquipmentsPendingClassification(),
            this.getRecommendationSummary(),
          ]);
        })
        .catch((error) => {
          this.ShowToast('Alerta', error?.response?.data.message, 'error');
        });
    },
    async refreshData() {
      await this.getRecommendationSummary();
      await this.getEquipmentClassifications();
      this.$forceUpdate();
    },
  },
};
</script>
<style lang="scss" scoped>
.fa-xlg {
  font-size: 2.5em;
  line-height: 0.75em;
  vertical-align: -0.0667em;
}

.text-gray-green {
  color: #3f5b60;
}

.text-neutral-gray {
  color: #727272;
}

.classification-item > div:last-child > span:first-child {
  font-size: 15px;
  line-height: normal;
}

.classification-item > div:last-child > span:last-child {
  font-size: 25px;
  line-height: normal;
  font-weight: 600;
}

.svg-icons {
  background-repeat: no-repeat;
  background-size: contain;
  height: 40px;
  width: 60px;
}

.svg-laptop-arrow-down-gray-green {
  background-image: url('../../../../assets/icons/laptop-arrow-down-gray-green.svg');
}

.svg-laptop-arrow-down-orange {
  background-image: url('../../../../assets/icons/laptop-arrow-down-orange.svg');
}

.svg-laptop-arrow-down-green {
  background-image: url('../../../../assets/icons/laptop-arrow-down-green.svg');
}

::v-deep .font-weight-bold {
  font-weight: 700 !important;
}
</style>
